const searchState = (state) => state;
const getCities = (state) => state.cities || [];
const getCounties = (state) => state.counties || [];
const getSeo = (state) => state.seo || null;
const getNearbyHomes = (state) => state.nearbyHomes || [];
export default {
    searchState,
    getCities,
    getCounties,
    getSeo,
    getNearbyHomes,
};
